const CROP_ZONE_TAGS_STRINGS = {
  viewEmptyStateMessage: 'Edit your crop zone information to add tags.',
  editCropZoneInformation: 'Edit Crop Zone Information'
} as const;

export default CROP_ZONE_TAGS_STRINGS;
